export default IconChartSankey => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chart-sankey" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 3v18h18" />
  <path d="M3 6h18" />
  <path d="M3 8c10 0 8 9 18 9" />
</svg>`;